class MultiStepForm {
    /**
     * Constructor
     */
    constructor(form) {
        this.form = form;
        this.stepElements = Array.from(this.form.querySelectorAll('.multistepform-step'));
        this.currentStep = this.getCurrentStep();
        this.nextStep = this.getNextStep();

        this.backendValidation = this.form.hasAttribute('data-multistepform-backendvalidation');
        this.backendValidationEndpoint = this.form.getAttribute('data-multistepform-backendvalidation') || this.form.action;

        this.requestInitTemplate = {
            method: this.form.method.toUpperCase(),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin'
        };

        this.form.MultiStepForm = this;

        this.registerEvents();
    }

    /**
     * Register events
     */
    registerEvents() {
        this.form.addEventListener('submit', (e) => {
            if (e.detail && e.detail.custom) return;
            if (this.nextStep) {
                e.preventDefault();
            }
            this.goToNextStep();
        });
    }

    /**
     * Current step fieldset
     * @return {Element}
     */
     getCurrentStep() {
        return this.stepElements.find((stepElement) => !stepElement.matches('[disabled]'));
    }

    /**
     * Next step fieldset | undefined
     * @return {Element|undefined}
     */
    getNextStep() {
        let currentStepIndex = this.stepElements.findIndex((stepElement) => stepElement.isSameNode(this.currentStep));
        return this.stepElements[currentStepIndex + 1];
    }


    /**
     * Validate step
     * @return Boolean
     */
    async validateStep() {
        if (!this.backendValidation) {
            if (this.form.checkValidity()) {
                return true;
            }
            return false;
        }

        let requestInit = Object.assign({}, this.requestInitTemplate);
        requestInit.body = new FormData(this.form);

        // make sure any custom validity added in a previous call is removed
        Array.from(this.form.elements).forEach((fieldElement) => {
            fieldElement.setCustomValidity('');
        });

        let fetchResult = await fetch(this.backendValidationEndpoint, requestInit)
            .then((response) => response.json())
            .then((response) => {
                if (!response.success) {
                    for (let fieldName in response) {
                        let fieldElement = this.currentStep.querySelector('[name="' + fieldName + '"]');
                        if (!fieldElement) continue;

                        fieldElement.setCustomValidity(response[fieldName]);
                        fieldElement.dispatchEvent(new CustomEvent('Validation:validate', {bubbles: true}));
                    }
                }

                if (!this.form.checkValidity()) {
                    return false;
                }

                return true;
            })
            .catch((e) => {
                console.log(e);
                return false;
            });

        return fetchResult;
    }


    /**
     * Go to next step
     * @return {Boolean}
     */
    async goToNextStep() {
        this.currentStep.classList.add('multistepform-step--loading');

        let validationResult = await this.validateStep();

        this.currentStep.classList.remove('multistepform-step--loading');

        if (!validationResult) {
            return false;
        }

        if (this.nextStep && this.nextStep !== undefined) {
            this.currentStep.classList.add('multistepform-step--completed');
            this.nextStep.disabled = false;

            this.currentStep = this.nextStep;
            this.nextStep = this.getNextStep();
        } else {
            this.nextStep = null;
            this.form.dispatchEvent(new CustomEvent('submit', {bubbles: true, detail: {'custom': true}}));
            return false;
        }

        return true;
    }

}

let multiStepForm = (function() {
    let formElements = document.querySelectorAll('[data-multistepform]');

    Array.from(formElements).forEach((formElement) => {
        if (formElement.MultiStepForm) return false;
        new MultiStepForm(formElement);
    });
})();
